module.exports = "#define GLSLIFY 1\nvec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\n\ngl_Position = projectionMatrix * mvPosition;\n"


//////////////////
// WEBPACK FOOTER
// ./src/vendor/three/renderers/shaders/ShaderChunk/project_vertex.glsl
// module id = 271
// module chunks = 0